<div
  class="reddi-tabular-checkbox"
  *ngFor="let checkbox of checkboxes"
  [ngClass]="{ 'background-active': checkbox.checked, large: type === 'large' }"
>
  <label [for]="'checkbox-' + checkbox.id">{{ checkbox.label }}</label>
  <input
    type="checkbox"
    [id]="'checkbox-' + checkbox.id"
    [(ngModel)]="checkbox.checked"
    (change)="onCheckboxChange(checkbox)"
  />
</div>
